import React from 'react';
import { ShortcutString } from '../../../shortcuts/shortcuts';
import { EditorTooltip } from '../../../controls/EditorTooltip';
import { cn } from '@gettactic/helpers';

export interface ShapeControlButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'title'> {
  title: React.ReactNode;
  shortcut?: ShortcutString;
  icon?: React.FC<{ size?: number | string }>;
}

export const ShapeControlButton: React.FC<ShapeControlButtonProps> = ({
  children,
  title,
  shortcut,
  className,
  icon,
  ...rest
}) => {
  return (
    <EditorTooltip message={title} shortcut={shortcut}>
      <button
        {...rest}
        className={cn(
          'flex gap-1 rounded p-1 text-gray-600 transition-colors hover:bg-gray-100',
          className
        )}
      >
        {icon ? React.createElement(icon, { size: 16 }) : undefined}
        {children}
      </button>
    </EditorTooltip>
  );
};
